module.exports = __webpack_public_path__ + "img/goldenbridge.5231d9c8.svg";